import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { nixaMOConfig } from "./data";

export default function NixaMOPage() {
  return <CityPageTemplate config={nixaMOConfig} />;
}